module.exports = __webpack_public_path__ + "static/img/gallery_4.e5c106f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/gallery_4.png
// module id = QnSO
// module chunks = 1